import { mixins } from 'vue-class-component';
import { MenuViewModel } from './MenuViewModel';
export default class Menu extends mixins(MenuViewModel) {}